import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadAccentFromCache } from './utils/theme';

// Global reset
const style = document.createElement('style');
style.textContent = `
  :root { --accent: #a3e635; }   /* cor de destaque padrão (customizável por lan house) */
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body, #root { width: 100%; min-width: 0; min-height: 100%; overflow-x: hidden; }
  html { height: -webkit-fill-available; background: #0a0a0f; touch-action: pan-x pan-y; }
  body { min-height: 100vh; min-height: 100dvh; background: #0a0a0f; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; overscroll-behavior: none; -webkit-text-size-adjust: 100%; text-size-adjust: 100%; }
  input, select, textarea, button { font-family: inherit; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: #374151; border-radius: 4px; }
`;
document.head.appendChild(style);
window.ARENA_WEBVIEW_READY = true;
loadAccentFromCache();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
